<template>
    <div>
        <div v-if="this.$route.path === '/home'">
            <div style="color: rgb(255, 255, 255); display: flex; align-items: center; right: 150px; position: absolute; top: 20px;">
                <span style="cursor: default; color: #fff; margin-left: 5px; font-size: 17px;">
                    <i v-show="statuss == 1" class="el-icon-s-custom"></i>
                    <i v-show="statuss == 2" style="color: #328ef4" class="el-icon-s-custom"></i>

                    <img style="width: 25px; position: absolute; left: -27px" v-show="statuss == 3" src="../../static/img/vip.png" alt="" />
                    <i v-show="statuss == 0" style="color: yellow" class="el-icon-s-custom"></i>
                    {{ nickName }}
                </span>
            </div>
            <p style="position: absolute; top: 20px; color: aliceblue; font-size: 25px; width: 135px; text-align: left; display: flex; right: 16px; align-items: center;">
                <!-- <el-tooltip class="item" effect="light" placement="bottom-start"> -->
                    <span v-show="!exit" @click="SignOut()" style="font-size: 17px; margin-left: 23px; color: #fff;cursor: pointer;">退出</span>
                <!-- </el-tooltip> -->
            </p>
        </div>
        
    </div>
</template>

<script>
export default {
    data () {
        return {
            statuss: 0,
            nickName: '',
            genre: '',
            exit: false,

            dlgPatternSettingShow: false,

            dlgDownloadShow: false,
            showstk: false
        }
    },
    methods: {
        openDlgPatternSetting () {
            this.dlgPatternSettingShow = true
        },
        gowd () {
            this.$router.push({ path: "/MultiPanel" })
        },
        goCustom () {
            this.$router.push({ path: "/custom" });
        },
        goUserCtrl () {
            this.$router.push({ path: "/userControl" });
        },
        goCommonSetting () {
            this.$router.push({ path: '/setting' })
        },
        SignOut() {
            // this.$axios.post('/cmsMateService/login.do?method=logoutForCheck', {
            //     username: sessionStorage.getItem("username")
            // }).then(res => {
            //     if (res.data.result === '200') {
            //         window.sessionStorage.clear()
            //         // window.localStorage.clear()
            //         this.$router.push({ path: "/login" })
            //     } else {
            //         this.$message({ message: res.data.message, type: 'error' })
            //     }
            // }).catch(error => {
            //     console.log(error)
            //     this.$message({ message: '请求异常', type: 'error' })
            // })
             window.sessionStorage.clear()
                    // window.localStorage.clear()
                    this.$router.push({ path: "/login" })
        },
        btnShowDownloadDlg () {
            this.dlgDownloadShow = true
            this.showstk = true // 为什么要在加这么个变量
        },
        showTS(v) {
            if (v == 1) {
                this.$message({
                    message: "高级用户与VIP用户可下载蓝太校验PC客户端！",
                    type: "warning",
                });
            } else if (v == 2) {
                this.$message({
                    message: "VIP用户可下载蓝太校验Android客户端！",
                    type: "warning",
                });
            } else {
                this.$message({
                    message: "VIP用户可下载蓝太校验IOS客户端！",
                    type: "warning",
                });
            }
        },
        // 加载网页配置：logo、网站名称、顶部背景色
        loadWebConfig () {
            this.$axios.post('/api/client/achieveWebConfig', {
                //
            }).then(res => {
                console.log(res)
                if (res.status === 200 && res.data.state === 1) {
                    this.$root.web_title = res.data.data.title
                    this.$root.web_logo = res.data.data.logoPath
                    this.$root.web_top_bc = res.data.data.backgroundColor
                    this.$root.web_logo_height = res.data.data.height
                    document.title = res.data.data.title
                } else {
                    this.$message({ message: '网站配置加载失败', type: 'error' })
                }
            }).catch(error => {
                console.log(error)
            })
        }
    },
    computed: {
        auditPattern1: {
            get () { return this.$root.auditPattern1 },
            set (val) {
                this.$root.auditPattern1 = val
            }
        },
        auditPattern2: {
            get () { return this.$root.auditPattern2 },
            set (val) {
                this.$root.auditPattern2 = val
            }
        },
        auditPattern3: {
            get () { return this.$root.auditPattern3 },
            set (val) {
                this.$root.auditPattern3 = val
            }
        }
    },
    watch: {
        $route (to, from) {
           this.statuss = parseInt(sessionStorage.getItem('status'))
            this.nickName = sessionStorage.getItem('nickname')
            this.genre = sessionStorage.getItem('genre')
            this.exit = this.nickName ? false : true
        }
    },
    mounted () {
        this.loadWebConfig()

         this.statuss = parseInt(sessionStorage.getItem('status'))
        this.nickName = sessionStorage.getItem('nickname')
        this.genre = sessionStorage.getItem('genre')
        this.exit = this.nickName ? false : true
    }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  background: #59b0b31c;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue